import Slide1 from "../../../../assets/onboarding-info/TalkingMari.png";
import Slide2 from "../../../../assets/onboarding-info/MariGlobe.png";

const slides = [
  {
    name: "checklist",
  },
  {
    name: "name",
    image: Slide1,
  },
  {
    name: "country",
    image: Slide2,
  },
  {
    name: "checklist2",
  },
];
export default slides;
